import * as React from 'react'
import cx from 'classnames'
import styles from './OpportunitiesListEmpty.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import Button from 'components/Button'
import { useBrandingSettings } from 'hooks/branding'

interface OpportunitiesListEmptyProps {
  /**
   * Empty state title.
   */
  title?: string
  /**
   * Empty state subtitle.
   */
  subtitle?: React.ReactNode
  /**
   * Illustration image URL.
   */
  imageSrc?: string
  /**
   * Callback for clearing the search filter.
   */
  onClearSearchFilterClick?: () => unknown
  /**
   * Children.
   */
  children?: React.ReactNode
}

export default function OpportunitiesListEmpty({
  subtitle,
  onClearSearchFilterClick,
  title = 'We looked everywhere...',
  imageSrc = require('assets/images/img_search-noresults.svg'),
  ...rest
}: OpportunitiesListEmptyProps) {
  const { corporateMode } = useBrandingSettings()

  subtitle = subtitle || (
    <>
      But we couldn't find what you were looking for.
      {onClearSearchFilterClick && (
        <>
          <br />
          Maybe try{' '}
          <Button
            size="baseline"
            onClick={onClearSearchFilterClick}
            type="text"
          >
            clearing your search filter
          </Button>{' '}
          ?
        </>
      )}
    </>
  )
  return (
    <div className={cx(styles.root)}>
      <EmptyState
        hideIllustration={corporateMode}
        animate
        small
        title={title}
        subtitle={subtitle}
        image={<EmptyStateIllustrationImage src={imageSrc} />}
        {...rest}
      />
    </div>
  )
}
